import React, { memo, forwardRef } from "react";
const SvgCapitalA = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.22 19.84h-6.5L11.7 22.3c-.16.4-.36.66-.6.78-.226.12-.447.18-.66.18-.346 0-.646-.107-.9-.32-.24-.227-.36-.533-.36-.92 0-.107.014-.213.04-.32.027-.12.074-.26.14-.42l5.1-11.34c.12-.267.247-.48.38-.64.133-.16.267-.28.4-.36.133-.08.267-.133.4-.16.133-.027.26-.04.38-.04s.247.013.38.04c.134.027.267.08.4.16.147.08.287.2.42.36.134.16.26.373.38.64l5.06 11.3c.067.16.107.3.12.42.027.12.04.22.04.3 0 .413-.133.733-.4.96-.253.227-.553.34-.9.34-.213 0-.44-.06-.68-.18-.227-.12-.427-.387-.6-.8l-1.02-2.44zm-5.6-2.16h4.72L16 12l-2.38 5.68z"
      />
    </svg>
  );
});
SvgCapitalA.displayName = "SvgCapitalA";
const MemoForwardRef = memo(SvgCapitalA);
export default MemoForwardRef;
